import {Box, Col, Row} from 'components/Grid';
import {Typography} from 'components/Typography';
import {FC} from 'react';
import style from './style.module.scss';

export const AboutTasting: FC = () => {
    return (
        <Box>
            <Row>
                <Col lg={3} md={12} sm={12}>
                    <Typography variant={'price-20-b'}>Как проходит мероприятие?</Typography>
                </Col>
                <Col className={style.separatorColumn} lg={1} md={12} sm={12}>
                    <div className={style.separatorContainer}>
                        <div className={style.separator} />
                    </div>
                </Col>
                <Col className={style.description} lg={7} md={12} sm={12}>
                    <Typography className={style.descriptionText} variant={'article-20'}>
                        Все мероприятия проходят в общем зале винотеки или в отдельной комнате. За 1,5–2 часа вы узнаете
                        о разных винных регионах, терруарах, особенностях производства и хранения вина, а также о выборе
                        гастрономических сочетаний. В программу входит дегустация 5–6 винных позиций в сопровождении
                        легких закусок. В завершение вечера мы предложим вам скидку 20% на ассортимент винотеки и 15% на
                        посещение следующего мероприятия с дегустацией. Скидки действуют только в день мероприятия и не
                        распространяются на сувениры, упаковку, товары с фиксированной ценой и Simple Collection.
                    </Typography>
                </Col>
            </Row>
        </Box>
    );
};
